import { createSlice, createAsyncThunk, addListener } from '@reduxjs/toolkit';
import { isTokenPotentiallyExpired, decodeJwtToken, localStorageEntry } from '@content-technology-partners-ltd/shared-util';
import axios, { isAxiosError } from 'axios';
import { buildCreateApi, coreModule } from '@reduxjs/toolkit/query';
import { reactHooksModule } from '@reduxjs/toolkit/dist/query/react';
import { popupModule } from '@content-technology-partners-ltd/popup';
import { retry } from '@reduxjs/toolkit/query/react';

function sharedDataAccess() {
    return "shared-data-access";
}

function _define_property$4(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$4(target, key, source[key]);
        });
    }
    return target;
}
var configInitialState = {
    baseUrl: "",
    stripePublishableKey: "",
    recaptchaSiteKey: "",
    supportEmail: "",
    zendeskSupportEmail: ""
};
var configSlice = createSlice({
    name: "config",
    initialState: configInitialState,
    reducers: {
        setConfig: function(state, action) {
            return _object_spread$4({}, state, action.payload);
        }
    }
});
var setConfig = configSlice.actions.setConfig;
var configReducer = configSlice.reducer;
configSlice.reducer;

var baseClient = function(param) {
    var getState = param.getState;
    var state = getState();
    return axios.create({
        baseURL: state.config.baseUrl
    });
};

function asyncGeneratorStep$9(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator$9(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$9(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$9(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator$9(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function getAuthHeaders(state, dispatch) {
    return _getAuthHeaders.apply(this, arguments);
}
function _getAuthHeaders() {
    _getAuthHeaders = _async_to_generator$9(function(state, dispatch) {
        var accessToken;
        return _ts_generator$9(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getAccessToken(state, dispatch)
                    ];
                case 1:
                    accessToken = _state.sent();
                    return [
                        2,
                        {
                            Authorization: "Bearer ".concat(accessToken)
                        }
                    ];
            }
        });
    });
    return _getAuthHeaders.apply(this, arguments);
}
function getAccessToken(state, dispatch) {
    return _getAccessToken.apply(this, arguments);
}
function _getAccessToken() {
    _getAccessToken = _async_to_generator$9(function(state, dispatch) {
        var _state_auth_tokens, accessToken, payload, tokens;
        return _ts_generator$9(this, function(_state) {
            switch(_state.label){
                case 0:
                    accessToken = (_state_auth_tokens = state.auth.tokens) === null || _state_auth_tokens === void 0 ? void 0 : _state_auth_tokens.accessToken;
                    payload = state.auth.tokenPayload;
                    if (!accessToken || !payload) {
                        throw new Error("No access token");
                    }
                    if (!isTokenPotentiallyExpired(payload, new Date())) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        dispatch(authRefreshTokenAction())
                    ];
                case 1:
                    tokens = _state.sent();
                    return [
                        2,
                        tokens.payload.accessToken
                    ];
                case 2:
                    return [
                        2,
                        accessToken
                    ];
            }
        });
    });
    return _getAccessToken.apply(this, arguments);
}

function asyncGeneratorStep$8(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator$8(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$8(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$8(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator$8(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var extendedClient = function(param) {
    var _param_auth = param.auth, auth = _param_auth === void 0 ? false : _param_auth, getState = param.getState, dispatch = param.dispatch;
    var axiosInstance = baseClient({
        getState: getState
    });
    if (auth) {
        axiosInstance.interceptors.request.use(function() {
            var _ref = _async_to_generator$8(function(request) {
                var headers;
                return _ts_generator$8(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                getAuthHeaders(getState(), dispatch)
                            ];
                        case 1:
                            headers = _state.sent();
                            request.headers.set(headers);
                            return [
                                2,
                                request
                            ];
                    }
                });
            });
            return function(request) {
                return _ref.apply(this, arguments);
            };
        }());
    }
    return axiosInstance;
};

function asyncGeneratorStep$7(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator$7(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$7(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$7(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator$7(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var EmailValidity;
(function(EmailValidity) {
    EmailValidity["VALID"] = "VALID";
    EmailValidity["SUSPECTED"] = "SUSPECTED";
    EmailValidity["INVALID"] = "INVALID";
})(EmailValidity || (EmailValidity = {}));
var authValidateEmailAction = createAsyncThunk("auth/validateEmail", function() {
    var _ref = _async_to_generator$7(function(authValidateEmailArgs, param) {
        var getState, rejectWithValue, response, error, errorMessages;
        return _ts_generator$7(this, function(_state) {
            switch(_state.label){
                case 0:
                    getState = param.getState, rejectWithValue = param.rejectWithValue;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        baseClient({
                            getState: getState
                        }).get("/auth/validation/email", {
                            params: authValidateEmailArgs
                        })
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        2,
                        response.data.data
                    ];
                case 3:
                    error = _state.sent();
                    errorMessages = error.response.data.messages;
                    return [
                        2,
                        rejectWithValue(errorMessages)
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function(authValidateEmailArgs, _) {
        return _ref.apply(this, arguments);
    };
}());
var authResetPasswordAction = createAsyncThunk("auth/resetPassword", function() {
    var _ref = _async_to_generator$7(function(authResetPasswordArgs, param) {
        var getState, rejectWithValue, error, errorMessages;
        return _ts_generator$7(this, function(_state) {
            switch(_state.label){
                case 0:
                    getState = param.getState, rejectWithValue = param.rejectWithValue;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        baseClient({
                            getState: getState
                        }).post("/auth/resetPassword", authResetPasswordArgs)
                    ];
                case 2:
                    _state.sent();
                    return [
                        2
                    ];
                case 3:
                    error = _state.sent();
                    errorMessages = error.response.data.messages;
                    return [
                        2,
                        rejectWithValue(errorMessages)
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function(authResetPasswordArgs, _) {
        return _ref.apply(this, arguments);
    };
}());
var authResendVerifyCodeAction = createAsyncThunk("auth/resendVerifyCode", function() {
    var _ref = _async_to_generator$7(function(authResendVerifyArgs, param) {
        var getState, rejectWithValue, error, errorMessages;
        return _ts_generator$7(this, function(_state) {
            switch(_state.label){
                case 0:
                    getState = param.getState, rejectWithValue = param.rejectWithValue;
                    if (!authResendVerifyArgs.email) {
                        throw new Error("Email is required");
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        baseClient({
                            getState: getState
                        }).post("/auth/verify-code", {
                            email: authResendVerifyArgs.email
                        })
                    ];
                case 2:
                    _state.sent();
                    return [
                        2,
                        {
                            isLoginRequest: authResendVerifyArgs.isLoginRequest
                        }
                    ];
                case 3:
                    error = _state.sent();
                    errorMessages = error.response.data.messages;
                    return [
                        2,
                        rejectWithValue(errorMessages)
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function(authResendVerifyArgs, _) {
        return _ref.apply(this, arguments);
    };
}());
var authVerifyAction = createAsyncThunk("auth/verify", function() {
    var _ref = _async_to_generator$7(function(authVerifyArgs, param) {
        var getState, rejectWithValue, response, _response_data_data, accessToken, refreshToken, error, errorMessages;
        return _ts_generator$7(this, function(_state) {
            switch(_state.label){
                case 0:
                    getState = param.getState, rejectWithValue = param.rejectWithValue;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    if (!authVerifyArgs.email) {
                        throw new Error("Email is required");
                    }
                    return [
                        4,
                        baseClient({
                            getState: getState
                        }).post("/auth/verify", authVerifyArgs)
                    ];
                case 2:
                    response = _state.sent();
                    _response_data_data = response.data.data, accessToken = _response_data_data.accessToken, refreshToken = _response_data_data.refreshToken;
                    return [
                        2,
                        {
                            accessToken: accessToken,
                            refreshToken: refreshToken
                        }
                    ];
                case 3:
                    error = _state.sent();
                    errorMessages = error.response.data.messages;
                    return [
                        2,
                        rejectWithValue(errorMessages)
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function(authVerifyArgs, _) {
        return _ref.apply(this, arguments);
    };
}());
var MarketingConsentType;
(function(MarketingConsentType) {
    MarketingConsentType[MarketingConsentType["optedOut"] = 1] = "optedOut";
    MarketingConsentType[MarketingConsentType["optedIn"] = 2] = "optedIn";
})(MarketingConsentType || (MarketingConsentType = {}));
var authSignupAction = createAsyncThunk("auth/signup", function() {
    var _ref = _async_to_generator$7(function(signupArgs, param) {
        var getState, rejectWithValue, error, _error_response, errorMessages;
        return _ts_generator$7(this, function(_state) {
            switch(_state.label){
                case 0:
                    getState = param.getState, rejectWithValue = param.rejectWithValue;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        baseClient({
                            getState: getState
                        }).post("/auth/signup", signupArgs)
                    ];
                case 2:
                    _state.sent();
                    return [
                        2
                    ];
                case 3:
                    error = _state.sent();
                    if (isAxiosError(error)) {
                        if (((_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.status) === 403 && error.response.headers["content-type"].includes("text/html") && error.response.data.includes("The request could not be satisfied")) {
                            return [
                                2,
                                rejectWithValue([
                                    {
                                        type: "VPNError",
                                        message: "VPN detected. Please disable it and try again",
                                        severity: ""
                                    }
                                ])
                            ];
                        }
                        errorMessages = error.response.data.messages;
                        return [
                            2,
                            rejectWithValue(errorMessages)
                        ];
                    }
                    throw error;
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function(signupArgs, _) {
        return _ref.apply(this, arguments);
    };
}());
var authLoginAction = createAsyncThunk("auth/login", function() {
    var _ref = _async_to_generator$7(function(param, param1) {
        var email, password, socialSignupCode, getState, rejectWithValue, response, error, errorMessages;
        return _ts_generator$7(this, function(_state) {
            switch(_state.label){
                case 0:
                    email = param.email, password = param.password, socialSignupCode = param.socialSignupCode, getState = param1.getState, rejectWithValue = param1.rejectWithValue;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        baseClient({
                            getState: getState
                        }).post("/auth/login", {
                            username: email,
                            password: password,
                            socialSignup: socialSignupCode
                        })
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        2,
                        response.data.data
                    ];
                case 3:
                    error = _state.sent();
                    errorMessages = error.response.data.messages;
                    return [
                        2,
                        rejectWithValue(errorMessages)
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function(_, _1) {
        return _ref.apply(this, arguments);
    };
}());
var authLogoutAction = createAsyncThunk("auth/logout", function() {
    var _ref = _async_to_generator$7(function(refreshToken, param) {
        var getState, rejectWithValue, error, errorMessages;
        return _ts_generator$7(this, function(_state) {
            switch(_state.label){
                case 0:
                    getState = param.getState, rejectWithValue = param.rejectWithValue;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        baseClient({
                            getState: getState
                        }).delete("/auth/logout", {
                            data: {
                                refreshToken: refreshToken
                            }
                        })
                    ];
                case 2:
                    _state.sent();
                    return [
                        2
                    ];
                case 3:
                    error = _state.sent();
                    errorMessages = error.response.data.message;
                    return [
                        2,
                        rejectWithValue(errorMessages)
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function(refreshToken, _) {
        return _ref.apply(this, arguments);
    };
}());
var authDeleteUserAction = createAsyncThunk("auth/deleteUser", function() {
    var _ref = _async_to_generator$7(function(_, param) {
        var getState, dispatch, rejectWithValue, e, errorMessages;
        return _ts_generator$7(this, function(_state) {
            switch(_state.label){
                case 0:
                    getState = param.getState, dispatch = param.dispatch, rejectWithValue = param.rejectWithValue;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        extendedClient({
                            auth: true,
                            getState: getState,
                            dispatch: dispatch
                        }).delete("/auth/user")
                    ];
                case 2:
                    _state.sent();
                    return [
                        2
                    ];
                case 3:
                    e = _state.sent();
                    errorMessages = e.response.data.message;
                    return [
                        2,
                        rejectWithValue(errorMessages)
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function(_, _1) {
        return _ref.apply(this, arguments);
    };
}());
var authLogoutAllDevicesAction = createAsyncThunk("auth/logoutAllDevices", function() {
    var _ref = _async_to_generator$7(function(_, param) {
        var dispatch, getState, rejectWithValue, error, errorMessages;
        return _ts_generator$7(this, function(_state) {
            switch(_state.label){
                case 0:
                    dispatch = param.dispatch, getState = param.getState, rejectWithValue = param.rejectWithValue;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        extendedClient({
                            dispatch: dispatch,
                            getState: getState,
                            auth: true
                        }).delete("/auth/logoutAllDevices")
                    ];
                case 2:
                    _state.sent();
                    return [
                        2
                    ];
                case 3:
                    error = _state.sent();
                    errorMessages = error.response.data.message;
                    return [
                        2,
                        rejectWithValue(errorMessages)
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function(_, _1) {
        return _ref.apply(this, arguments);
    };
}());
var authRefreshTokenAction = createAsyncThunk("auth/refreshToken", function() {
    var _ref = _async_to_generator$7(function(_, param) {
        var getState, _getState_auth_tokens, refreshToken, response;
        return _ts_generator$7(this, function(_state) {
            switch(_state.label){
                case 0:
                    getState = param.getState;
                    refreshToken = (_getState_auth_tokens = getState().auth.tokens) === null || _getState_auth_tokens === void 0 ? void 0 : _getState_auth_tokens.refreshToken;
                    return [
                        4,
                        baseClient({
                            getState: getState
                        }).post("/auth/refresh-token", {
                            refreshToken: refreshToken
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return function(_, _1) {
        return _ref.apply(this, arguments);
    };
}());
var authChangePasswordAction = createAsyncThunk("auth/changePassword", function() {
    var _ref = _async_to_generator$7(function(authChangePasswordArgs, param) {
        var getState, dispatch, rejectWithValue, response, error, errorMessages;
        return _ts_generator$7(this, function(_state) {
            switch(_state.label){
                case 0:
                    getState = param.getState, dispatch = param.dispatch, rejectWithValue = param.rejectWithValue;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        extendedClient({
                            dispatch: dispatch,
                            getState: getState,
                            auth: true
                        }).put("/auth/user", authChangePasswordArgs)
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
                case 3:
                    error = _state.sent();
                    errorMessages = error.response.data.messages;
                    return [
                        2,
                        rejectWithValue(errorMessages)
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function(authChangePasswordArgs, _) {
        return _ref.apply(this, arguments);
    };
}());
var authNewPasswordAction = createAsyncThunk("auth/newPassword", function() {
    var _ref = _async_to_generator$7(function(param, param1) {
        var password, resetPasswordCode, getState, rejectWithValue, response, error, errorMessages;
        return _ts_generator$7(this, function(_state) {
            switch(_state.label){
                case 0:
                    password = param.password, resetPasswordCode = param.resetPasswordCode, getState = param1.getState, rejectWithValue = param1.rejectWithValue;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        baseClient({
                            getState: getState
                        }).post("/auth/login", {
                            password: password,
                            verificationCode: resetPasswordCode
                        })
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        2,
                        response.data.data
                    ];
                case 3:
                    error = _state.sent();
                    errorMessages = error.response.data.messages;
                    return [
                        2,
                        rejectWithValue(errorMessages)
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function(_, _1) {
        return _ref.apply(this, arguments);
    };
}());
var authDisconnectSocialAccountAction = createAsyncThunk("auth/disconnectSocialAccount", function() {
    var _ref = _async_to_generator$7(function(param, param1) {
        var socialSignupType, getState, dispatch, rejectWithValue, response, error, errorMessages;
        return _ts_generator$7(this, function(_state) {
            switch(_state.label){
                case 0:
                    socialSignupType = param.socialSignupType, getState = param1.getState, dispatch = param1.dispatch, rejectWithValue = param1.rejectWithValue;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        extendedClient({
                            dispatch: dispatch,
                            getState: getState,
                            auth: true
                        }).delete("/auth/social/contact/".concat(socialSignupType))
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
                case 3:
                    error = _state.sent();
                    errorMessages = error.response.data.messages;
                    return [
                        2,
                        rejectWithValue(errorMessages)
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function(_, _1) {
        return _ref.apply(this, arguments);
    };
}());

function _define_property$3(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$3(target, key, source[key]);
        });
    }
    return target;
}
var tokensToAuthState = function(tokens) {
    return {
        tokens: tokens,
        tokenPayload: tokens && decodeJwtToken(tokens.accessToken)
    };
};
var LOCAL_STORAGE_KEY = "authTokens";
var updateTokensReducer = function(state, action) {
    return _object_spread$3({}, state, tokensToAuthState(action.payload));
};
var initialState = {
    tokens: null,
    tokenPayload: null
};
var initialStateReducer = function() {
    return _object_spread$3({}, initialState);
};
var authSlice = createSlice({
    name: "auth",
    initialState: initialState,
    reducers: {
        updateTokens: updateTokensReducer
    },
    extraReducers: function(builder) {
        return builder.addCase(authLoginAction.fulfilled, updateTokensReducer).addCase(authRefreshTokenAction.fulfilled, updateTokensReducer).addCase(authVerifyAction.fulfilled, updateTokensReducer).addCase(authLogoutAction.fulfilled, initialStateReducer).addCase(authLogoutAllDevicesAction.fulfilled, initialStateReducer).addCase(authNewPasswordAction.fulfilled, initialStateReducer);
    }
});
var updateTokens = authSlice.actions.updateTokens;
var authReducer = authSlice.reducer;
authSlice.reducer;

var isUserLoggedIn = function(state) {
    return !!state.auth.tokens;
};

var TypeOfRole;
(function(TypeOfRole) {
    TypeOfRole["User"] = "User";
    TypeOfRole["ChannelManager"] = "ChannelManager";
    TypeOfRole["PartnerManager"] = "PartnerManager";
})(TypeOfRole || (TypeOfRole = {}));
var PermissionType;
(function(PermissionType) {
    PermissionType["Admin"] = "ADMIN";
})(PermissionType || (PermissionType = {}));
var SocialSignupType;
(function(SocialSignupType) {
    SocialSignupType["google"] = "google";
    SocialSignupType["facebook"] = "facebook";
})(SocialSignupType || (SocialSignupType = {}));

var addAuthStateListener = function(effect) {
    return addListener({
        predicate: function(_, current, previous) {
            return current.auth !== previous.auth;
        },
        effect: function(_, param) {
            var getState = param.getState;
            return effect(getState().auth);
        }
    });
};

var authStorage = [
    {
        selector: function(state) {
            return state.auth.tokens;
        },
        actionCreator: updateTokens,
        entry: localStorageEntry("authTokens", null)
    }
];

var createApi = buildCreateApi(coreModule(), reactHooksModule(), popupModule());

function asyncGeneratorStep$6(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator$6(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$6(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$6(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _object_without_properties$2(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose$2(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose$2(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _ts_generator$6(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var baseQuery = function() {
    return function() {
        var _ref = _async_to_generator$6(function(args, api) {
            var _ref, auth, axiosArgs, _tmp, dispatch, getState, client, result, axiosError, _err_response, _err_response1, err;
            return _ts_generator$6(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(typeof args === "function")) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            args(api)
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = args;
                        _state.label = 3;
                    case 3:
                        _ref = _tmp, auth = _ref.auth, axiosArgs = _object_without_properties$2(_ref, [
                            "auth"
                        ]);
                        dispatch = api.dispatch, getState = api.getState;
                        client = extendedClient({
                            getState: getState,
                            dispatch: dispatch,
                            auth: auth
                        });
                        _state.label = 4;
                    case 4:
                        _state.trys.push([
                            4,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4,
                            client.request(axiosArgs)
                        ];
                    case 5:
                        result = _state.sent();
                        return [
                            2,
                            {
                                data: result.data
                            }
                        ];
                    case 6:
                        axiosError = _state.sent();
                        err = axiosError;
                        return [
                            2,
                            {
                                error: {
                                    status: (_err_response = err.response) === null || _err_response === void 0 ? void 0 : _err_response.status,
                                    data: ((_err_response1 = err.response) === null || _err_response1 === void 0 ? void 0 : _err_response1.data) || err.message
                                }
                            }
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function(args, api) {
            return _ref.apply(this, arguments);
        };
    }();
};

function asyncGeneratorStep$5(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator$5(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$5(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$5(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator$5(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var defaultMediaApiCacheTimeSeconds = 3600;
var mediaApi = createApi({
    reducerPath: "mediaApi",
    baseQuery: retry(baseQuery(), {
        maxRetries: 0
    }),
    tagTypes: [
        "wallet"
    ],
    endpoints: function(builder) {
        return {
            getCountries: builder.query({
                query: function() {
                    return {
                        url: "/v2/countries"
                    };
                },
                transformResponse: function(response) {
                    return response.data.items;
                },
                keepUnusedDataFor: defaultMediaApiCacheTimeSeconds
            }),
            getLocation: builder.query({
                query: function() {
                    return {
                        url: "/v2/location"
                    };
                },
                transformResponse: function(response) {
                    return response.data;
                },
                keepUnusedDataFor: defaultMediaApiCacheTimeSeconds
            }),
            getMeWallet: builder.query({
                query: function() {
                    return {
                        url: "/v2/me/wallet",
                        auth: true
                    };
                },
                transformResponse: function(response) {
                    return response.data;
                },
                keepUnusedDataFor: defaultMediaApiCacheTimeSeconds,
                providesTags: [
                    "wallet"
                ],
                extraOptions: {
                    maxRetries: 5
                }
            }),
            getTransactions: builder.query({
                query: function() {
                    return {
                        url: "/v2/user/transactions",
                        auth: true
                    };
                },
                transformResponse: function(response) {
                    return response.data;
                },
                keepUnusedDataFor: defaultMediaApiCacheTimeSeconds,
                extraOptions: {
                    maxRetries: 5
                }
            }),
            getVideoPlay: builder.query({
                query: function(videoId) {
                    return {
                        url: "/v2/video/play/".concat(videoId),
                        method: "POST",
                        data: {
                            castPrice: 0
                        },
                        auth: true
                    };
                },
                transformResponse: function(response) {
                    return response.data;
                }
            }),
            buyVideoPlay: builder.mutation({
                query: function(param) {
                    var videoId = param.videoId, castPrice = param.castPrice;
                    return {
                        url: "/v2/video/play/".concat(videoId),
                        method: "POST",
                        data: {
                            castPrice: castPrice
                        },
                        auth: true
                    };
                },
                transformResponse: function(response) {
                    return response.data;
                },
                onQueryStarted: function() {
                    var _ref = _async_to_generator$5(function(param, param1) {
                        var videoId, dispatch, queryFulfilled, _mediaApi_util, updateQueryData, upsertQueryData, data, balance;
                        return _ts_generator$5(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    videoId = param.videoId, dispatch = param1.dispatch, queryFulfilled = param1.queryFulfilled;
                                    _mediaApi_util = mediaApi.util, updateQueryData = _mediaApi_util.updateQueryData, upsertQueryData = _mediaApi_util.upsertQueryData;
                                    return [
                                        4,
                                        queryFulfilled
                                    ];
                                case 1:
                                    data = _state.sent().data;
                                    dispatch(upsertQueryData("getVideoPlay", videoId, data));
                                    balance = data.balance;
                                    if (typeof balance === "object") {
                                        dispatch(updateQueryData("getMeWallet", undefined, function(account) {
                                            account.balance = balance;
                                        }));
                                    }
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(_, _1) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                invalidatesTags: function(result) {
                    return (result === null || result === void 0 ? void 0 : result.balance) === "changed" ? [
                        "wallet"
                    ] : [];
                }
            }),
            followChannel: builder.mutation({
                query: function(channelId) {
                    return {
                        url: "/v2/user/follow/".concat(channelId),
                        method: "POST",
                        auth: true
                    };
                }
            }),
            getHomeProfile: builder.query({
                query: function() {
                    return {
                        url: "/v2/me/homeProfile",
                        method: "GET",
                        auth: true
                    };
                },
                transformResponse: function(response) {
                    return response.data;
                },
                keepUnusedDataFor: defaultMediaApiCacheTimeSeconds
            })
        };
    }
});
var useGetCountriesQuery = mediaApi.useGetCountriesQuery, useGetLocationQuery = mediaApi.useGetLocationQuery, useGetMeWalletQuery = mediaApi.useGetMeWalletQuery, useGetTransactionsQuery = mediaApi.useGetTransactionsQuery, useGetHomeProfileQuery = mediaApi.useGetHomeProfileQuery;

function asyncGeneratorStep$4(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator$4(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$4(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$4(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator$4(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function getEndpointData(endpoint, args, options) {
    return function() {
        var _ref = _async_to_generator$4(function(dispatch) {
            var query, data;
            return _ts_generator$4(this, function(_state) {
                switch(_state.label){
                    case 0:
                        query = dispatch(endpoint.initiate(args, options));
                        return [
                            4,
                            query.unwrap()
                        ];
                    case 1:
                        data = _state.sent();
                        query.unsubscribe();
                        return [
                            2,
                            data
                        ];
                }
            });
        });
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
}

function asyncGeneratorStep$3(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator$3(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$3(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$3(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator$3(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var paymentApi = createApi({
    reducerPath: "paymentApi",
    baseQuery: baseQuery(),
    endpoints: function(builder) {
        return {
            getConfig: builder.query({
                query: function() {
                    return function() {
                        var _ref = _async_to_generator$3(function(param) {
                            var dispatch, location;
                            return _ts_generator$3(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        dispatch = param.dispatch;
                                        return [
                                            4,
                                            dispatch(getEndpointData(mediaApi.endpoints.getLocation))
                                        ];
                                    case 1:
                                        location = _state.sent().location;
                                        return [
                                            2,
                                            {
                                                url: "/payment/config",
                                                params: {
                                                    country: location
                                                },
                                                auth: true
                                            }
                                        ];
                                }
                            });
                        });
                        return function(_) {
                            return _ref.apply(this, arguments);
                        };
                    }();
                },
                transformResponse: function(response) {
                    return response.data;
                }
            })
        };
    }
});
var useGetConfigQuery = paymentApi.useGetConfigQuery;

var authApi = createApi({
    reducerPath: "authApi",
    baseQuery: retry(baseQuery(), {
        maxRetries: 0
    }),
    endpoints: function(builder) {
        return {
            getContact: builder.query({
                query: function() {
                    return {
                        url: "/auth/user/contact",
                        method: "GET",
                        auth: true
                    };
                },
                transformResponse: function(response) {
                    return response.data;
                }
            })
        };
    }
});
var useGetContactQuery = authApi.useGetContactQuery;

function asyncGeneratorStep$2(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator$2(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$2(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$2(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator$2(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var createPayment = function(amount, currency, casts) {
    return function() {
        var _ref = _async_to_generator$2(function(dispatch, getState) {
            var client, res;
            return _ts_generator$2(this, function(_state) {
                switch(_state.label){
                    case 0:
                        client = extendedClient({
                            dispatch: dispatch,
                            getState: getState,
                            auth: true
                        });
                        return [
                            4,
                            client.post("/payment/create", {
                                amount: amount,
                                currency: currency,
                                casts: casts
                            })
                        ];
                    case 1:
                        res = _state.sent();
                        return [
                            2,
                            res.data.data
                        ];
                }
            });
        });
        return function(dispatch, getState) {
            return _ref.apply(this, arguments);
        };
    }();
};

var isChannelPass = function(item) {
    return item.href.startsWith("/api/public/tariffs/") && item.type === "CHANNEL_PASS";
};
var isChannelListing = function(item) {
    return item.href.startsWith("/partner/channel/");
};

function _define_property$2(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$2(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$2(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties$1(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose$1(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose$1(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function getPublicUrl(prefix, itemRef) {
    if (typeof itemRef === "string" || typeof itemRef === "number") {
        return "".concat(prefix).concat(itemRef);
    }
    return itemRef.href;
}
var publicQuery = function(_param) {
    var prefix = _param.prefix, queryArgs = _object_without_properties$1(_param, [
        "prefix"
    ]);
    return {
        query: function(itemRef) {
            return _object_spread_props$2(_object_spread$2({}, queryArgs), {
                url: getPublicUrl(prefix, itemRef)
            });
        },
        serializeQueryArgs: function(param) {
            var queryArgs = param.queryArgs;
            return getPublicUrl(prefix, queryArgs);
        }
    };
};

function _define_property$1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$1(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$1(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var publicApi = createApi({
    reducerPath: "publicApi",
    baseQuery: baseQuery(),
    endpoints: function(builder) {
        return {
            getVideo: builder.query(_object_spread_props$1(_object_spread$1({}, publicQuery({
                prefix: "/api/public/videos/"
            })), {
                keepUnusedDataFor: 60,
                transformResponse: function(response) {
                    var _response_data = response.data, item = _response_data.item, expanded = _response_data.expanded;
                    var channelPasses = expanded.filter(isChannelPass);
                    var channels = expanded.filter(isChannelListing).map(function(channel) {
                        return _object_spread_props$1(_object_spread$1({}, channel), {
                            channelPasses: channel.channelPasses.map(function(passLink) {
                                return channelPasses.find(function(pass) {
                                    return pass.href === passLink.href;
                                });
                            })
                        });
                    });
                    var channel = channels.find(function(channel) {
                        return channel.href === item.channel.href;
                    });
                    return _object_spread_props$1(_object_spread$1({}, item), {
                        channel: channel
                    });
                }
            })),
            getChannels: builder.query({
                query: function(uids) {
                    return {
                        url: "/api/public/channels",
                        method: "GET",
                        params: {
                            "channels.id": uids.join(",")
                        }
                    };
                },
                transformResponse: function(response) {
                    return response.data.channels;
                }
            })
        };
    }
});
var useGetVideoQuery = publicApi.useGetVideoQuery;

var PromotionType;
(function(PromotionType) {
    PromotionType["paidPlacement"] = "paidPlacement";
    PromotionType["productPromotion"] = "productPromotion";
    PromotionType["embeddedAdvertising"] = "embeddedAdvertising";
    PromotionType["sponsoredContent"] = "sponsoredContent";
    PromotionType["otherPromotion"] = "otherPromotion";
    PromotionType["brandedPaidOrAdvertorials"] = "brandedPaidOrAdvertorials";
    PromotionType["preRollOrAdBreaks"] = "preRollOrAdBreaks";
    PromotionType["sponsored"] = "sponsored";
    PromotionType["productPlacement"] = "productPlacement";
    PromotionType["selfPromotional"] = "selfPromotional";
    PromotionType["affiliateMarketing"] = "affiliateMarketing";
})(PromotionType || (PromotionType = {}));
var VideoListingTypes;
(function(VideoListingTypes) {
    VideoListingTypes["ON_DEMAND"] = "ondemand";
    VideoListingTypes["LIVE"] = "live";
    VideoListingTypes["FREE"] = "free";
})(VideoListingTypes || (VideoListingTypes = {}));
var VideoListingStreamTypes;
(function(VideoListingStreamTypes) {
    VideoListingStreamTypes["DEVICE"] = "device";
    VideoListingStreamTypes["RTMP"] = "rtmp";
})(VideoListingStreamTypes || (VideoListingStreamTypes = {}));
var VideoListingLiveDetailsStatusMessageType;
(function(VideoListingLiveDetailsStatusMessageType) {
    VideoListingLiveDetailsStatusMessageType["error"] = "ERROR";
    VideoListingLiveDetailsStatusMessageType["info"] = "INFO";
})(VideoListingLiveDetailsStatusMessageType || (VideoListingLiveDetailsStatusMessageType = {}));
var VideoListingLiveDetailsStatus;
(function(VideoListingLiveDetailsStatus) {
    VideoListingLiveDetailsStatus["notLive"] = "notLive";
    VideoListingLiveDetailsStatus["live"] = "live";
    VideoListingLiveDetailsStatus["finished"] = "finished";
})(VideoListingLiveDetailsStatus || (VideoListingLiveDetailsStatus = {}));
var VideoListingReplayStatus;
(function(VideoListingReplayStatus) {
    VideoListingReplayStatus["pending"] = "pending";
    VideoListingReplayStatus["live"] = "live";
})(VideoListingReplayStatus || (VideoListingReplayStatus = {}));
var VideoOrder;
(function(VideoOrder) {
    VideoOrder["relevancy"] = "relevancy";
    VideoOrder["publishTime"] = "publishTime";
    VideoOrder["ranking"] = "ranking";
    VideoOrder["liveStartTime"] = "liveStartTime";
})(VideoOrder || (VideoOrder = {}));

var isPurchase = function(item) {
    return item.href.startsWith("/api/public/purchases");
};
var isTarrif = function(item) {
    return item.href.startsWith("/api/public/tariffs");
};
var hrefContainsId = function(href, id) {
    return href.split("/api/public/products/")[1] === id;
};

function asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator$1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator$1(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var PublisherDataShareScopes;
(function(PublisherDataShareScopes) {
    PublisherDataShareScopes["email"] = "email";
    PublisherDataShareScopes["basicProfile"] = "basicProfile";
})(PublisherDataShareScopes || (PublisherDataShareScopes = {}));
var UserConsentType;
(function(UserConsentType) {
    UserConsentType["shareWithAdProviders"] = "shareWithAdProviders";
    UserConsentType["marketing"] = "marketing";
})(UserConsentType || (UserConsentType = {}));
var UserConsentStatus;
(function(UserConsentStatus) {
    UserConsentStatus["granted"] = "GRANTED";
    UserConsentStatus["revoked"] = "REVOKED";
})(UserConsentStatus || (UserConsentStatus = {}));
var GenderType;
(function(GenderType) {
    GenderType["Male"] = "MALE";
    GenderType["Female"] = "FEMALE";
    GenderType["Other"] = "OTHER";
    GenderType["SelfDescribed"] = "SELF_DESCRIBED";
})(GenderType || (GenderType = {}));
var UserBonusType;
(function(UserBonusType) {
    UserBonusType["dataConsentBonus"] = "dataConsentBonus";
})(UserBonusType || (UserBonusType = {}));
var profileApi = createApi({
    reducerPath: "profileApi",
    baseQuery: baseQuery(),
    endpoints: function(builder) {
        return {
            getProfileData: builder.query({
                query: function(param) {
                    var userConsents = param.userConsents;
                    return {
                        url: "/api/private/me/profile",
                        params: {
                            expand: userConsents ? "userConsents" : undefined
                        },
                        method: "get",
                        auth: true
                    };
                },
                transformResponse: function(response, _, arg) {
                    return {
                        profileData: response.data.item,
                        userConsents: arg.userConsents ? response.data.expanded.filter(function(item) {
                            return item.href.startsWith("/api/private/me/consents");
                        }) : undefined
                    };
                }
            }),
            getBonuses: builder.query({
                query: function() {
                    return {
                        url: "/api/private/me/bonuses",
                        method: "get",
                        auth: true
                    };
                },
                transformResponse: function(response) {
                    return response.data.item.bonuses.map(function(bonus) {
                        return bonus.bonusType;
                    });
                },
                onQueryStarted: function() {
                    var _ref = _async_to_generator$1(function(_, param) {
                        var dispatch, queryFulfilled;
                        return _ts_generator$1(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    dispatch = param.dispatch, queryFulfilled = param.queryFulfilled;
                                    return [
                                        4,
                                        queryFulfilled
                                    ];
                                case 1:
                                    _state.sent();
                                    dispatch(mediaApi.endpoints.getMeWallet.initiate(undefined, {
                                        forceRefetch: true
                                    }));
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(_, _1) {
                        return _ref.apply(this, arguments);
                    };
                }()
            }),
            updateProfileData: builder.mutation({
                query: function(profileData) {
                    return {
                        url: "/api/private/me/profile",
                        method: "put",
                        auth: true,
                        data: {
                            item: profileData
                        }
                    };
                },
                onQueryStarted: function() {
                    var _ref = _async_to_generator$1(function(_, param) {
                        var dispatch, queryFulfilled, data;
                        return _ts_generator$1(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    dispatch = param.dispatch, queryFulfilled = param.queryFulfilled;
                                    return [
                                        4,
                                        queryFulfilled
                                    ];
                                case 1:
                                    data = _state.sent().data;
                                    dispatch(profileApi.util.updateQueryData("getProfileData", {
                                        userConsents: true
                                    }, function(oldData) {
                                        oldData.profileData = data.data.item;
                                    }));
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(_, _1) {
                        return _ref.apply(this, arguments);
                    };
                }()
            }),
            updateUserConsent: builder.mutation({
                query: function(userConsent) {
                    return {
                        url: "/api/private/me/consents/".concat(userConsent.consentType),
                        method: "put",
                        auth: true,
                        data: {
                            item: {
                                status: userConsent.status,
                                appliesTo: userConsent.appliesTo
                            }
                        }
                    };
                },
                onQueryStarted: function() {
                    var _ref = _async_to_generator$1(function(param, param1) {
                        var consentType, dispatch, queryFulfilled, data;
                        return _ts_generator$1(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    consentType = param.consentType, dispatch = param1.dispatch, queryFulfilled = param1.queryFulfilled;
                                    return [
                                        4,
                                        queryFulfilled
                                    ];
                                case 1:
                                    data = _state.sent().data;
                                    dispatch(profileApi.util.updateQueryData("getProfileData", {
                                        userConsents: true
                                    }, function(oldData) {
                                        var _oldData_userConsents;
                                        var consent = (_oldData_userConsents = oldData.userConsents) === null || _oldData_userConsents === void 0 ? void 0 : _oldData_userConsents.find(function(consent) {
                                            return consent.consentType === consentType;
                                        });
                                        if (consent) {
                                            consent.appliesTo = data.data.item.appliesTo;
                                            consent.status = data.data.item.status;
                                        } else {
                                            var _oldData_userConsents1;
                                            (_oldData_userConsents1 = oldData.userConsents) === null || _oldData_userConsents1 === void 0 ? void 0 : _oldData_userConsents1.push({
                                                href: "/api/private/me/consents/".concat(consentType),
                                                consentType: consentType,
                                                appliesTo: data.data.item.appliesTo,
                                                status: data.data.item.status
                                            });
                                        }
                                    }));
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(_, _1) {
                        return _ref.apply(this, arguments);
                    };
                }()
            }),
            getPublisherDataShare: builder.query({
                query: function() {
                    return {
                        url: "/api/private/me/publisherDataShare",
                        method: "get",
                        auth: true
                    };
                },
                transformResponse: function(data) {
                    return data.data.expanded.map(function(param) {
                        var channelUid = param.channelUid, scopes = param.scopes;
                        return {
                            channelUid: channelUid,
                            scopes: scopes
                        };
                    });
                }
            }),
            updatePublishersDataShare: builder.mutation({
                query: function(publishersDataShare) {
                    return {
                        url: "/api/private/me/publisherDataShare",
                        method: "put",
                        auth: true,
                        data: {
                            items: publishersDataShare
                        }
                    };
                },
                onQueryStarted: function() {
                    var _ref = _async_to_generator$1(function(_, param) {
                        var dispatch, queryFulfilled, data;
                        return _ts_generator$1(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    dispatch = param.dispatch, queryFulfilled = param.queryFulfilled;
                                    return [
                                        4,
                                        queryFulfilled
                                    ];
                                case 1:
                                    data = _state.sent().data;
                                    dispatch(profileApi.util.upsertQueryData("getPublisherDataShare", undefined, data.data.expanded.map(function(param) {
                                        var channelUid = param.channelUid, scopes = param.scopes;
                                        return {
                                            channelUid: channelUid,
                                            scopes: scopes
                                        };
                                    })));
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(_, _1) {
                        return _ref.apply(this, arguments);
                    };
                }()
            })
        };
    }
});

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var purchaseApi = createApi({
    reducerPath: "purchaseApi",
    baseQuery: baseQuery(),
    tagTypes: [
        "purchase"
    ],
    endpoints: function(builder) {
        return {
            legacyGetVideoPlay: builder.query({
                query: function(videoId) {
                    return {
                        url: "/api/public/legacy/play/".concat(videoId),
                        method: "POST",
                        data: {
                            castPrice: 0
                        },
                        auth: true
                    };
                },
                transformResponse: function(response) {
                    return response.data;
                }
            }),
            getPurchasedChannelPasses: builder.query({
                query: function() {
                    return {
                        url: "/api/public/me/purchases?type=CHANNEL_PASS&expand=tariffs",
                        auth: true
                    };
                },
                providesTags: [
                    "purchase"
                ],
                transformResponse: function(response) {
                    var channelPasses = response.data.expanded.filter(isChannelPass);
                    var purchases = response.data.expanded.filter(isPurchase);
                    return purchases.map(function(purchase) {
                        return _object_spread_props(_object_spread({}, purchase), {
                            tariff: channelPasses.find(function(channelPass) {
                                return channelPass.href === purchase.tariff.href;
                            })
                        });
                    });
                }
            }),
            purchaseTariff: builder.mutation({
                query: function(param) {
                    var tariff = param.tariff, source = param.source, recasterUid = param.recasterUid, referrer = param.referrer, widgetId = param.widgetId, sourceChannelId = param.sourceChannelId;
                    return {
                        url: "/api/public/me/purchases",
                        method: "post",
                        auth: true,
                        data: {
                            tariff: {
                                href: tariff.href
                            },
                            recaster: recasterUid ? {
                                id: recasterUid
                            } : undefined,
                            referrer: referrer ? {
                                id: referrer
                            } : undefined,
                            metadata: {
                                source: source,
                                widgetId: widgetId,
                                channelId: sourceChannelId
                            }
                        }
                    };
                },
                invalidatesTags: [
                    "purchase"
                ],
                onQueryStarted: function() {
                    var _ref = _async_to_generator(function(_, param) {
                        var dispatch, queryFulfilled;
                        return _ts_generator(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    dispatch = param.dispatch, queryFulfilled = param.queryFulfilled;
                                    return [
                                        4,
                                        queryFulfilled
                                    ];
                                case 1:
                                    _state.sent();
                                    dispatch(mediaApi.util.invalidateTags([
                                        "wallet"
                                    ]));
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(_, _1) {
                        return _ref.apply(this, arguments);
                    };
                }()
            }),
            getMyPurchasesTariffs: builder.query({
                query: function() {
                    return {
                        url: "/api/public/me/purchases?expand=tariffs",
                        auth: true
                    };
                },
                providesTags: [
                    "purchase"
                ],
                transformResponse: function(response) {
                    var tarrifs = response.data.expanded.filter(isTarrif);
                    return tarrifs;
                }
            }),
            purchaseIntent: builder.mutation({
                query: function(intentToken) {
                    return {
                        url: "/api/v0/user/purchases",
                        method: "POST",
                        auth: true,
                        data: {
                            intentToken: intentToken
                        }
                    };
                }
            }),
            productAccessStatus: builder.query({
                query: function(params) {
                    return {
                        url: "/api/v0/vendor/products/access",
                        method: "GET",
                        auth: true,
                        body: params
                    };
                }
            }),
            purchaseConfirmation: builder.query({
                query: function(params) {
                    var purchaseId = params.purchaseId, data = _object_without_properties(params, [
                        "purchaseId"
                    ]);
                    return {
                        url: "/api/v0/user/purchases/".concat(purchaseId, "/confirmation"),
                        method: "POST",
                        auth: true,
                        data: data
                    };
                }
            })
        };
    }
});
var useLegacyGetVideoPlayQuery = purchaseApi.useLegacyGetVideoPlayQuery;

var PublisherStreamStatus;
(function(PublisherStreamStatus) {
    PublisherStreamStatus["PENDING"] = "pending";
    PublisherStreamStatus["FETCHING_URL"] = "fetching-url";
    PublisherStreamStatus["CREATING"] = "creating";
    PublisherStreamStatus["CREATE_FAILED"] = "create-failed";
    PublisherStreamStatus["CREATED"] = "created";
    PublisherStreamStatus["TESTING"] = "testing";
    PublisherStreamStatus["LIVE"] = "live";
    PublisherStreamStatus["DELETING"] = "deleting";
    PublisherStreamStatus["DELETE_FAILED"] = "delete-failed";
    PublisherStreamStatus["DELETED"] = "deleted";
})(PublisherStreamStatus || (PublisherStreamStatus = {}));
var PublisherDrmProviderName;
(function(PublisherDrmProviderName) {
    PublisherDrmProviderName["BuyDrm"] = "buydrm";
    PublisherDrmProviderName["None"] = "";
})(PublisherDrmProviderName || (PublisherDrmProviderName = {}));
var PublisherVideoTypeId;
(function(PublisherVideoTypeId) {
    PublisherVideoTypeId[PublisherVideoTypeId["UPLOAD"] = 0] = "UPLOAD";
    PublisherVideoTypeId[PublisherVideoTypeId["BROADCAST"] = 4] = "BROADCAST";
    PublisherVideoTypeId[PublisherVideoTypeId["AD"] = 5] = "AD";
    PublisherVideoTypeId[PublisherVideoTypeId["FREE"] = 6] = "FREE";
})(PublisherVideoTypeId || (PublisherVideoTypeId = {}));

var endpointsApi = createApi({
    reducerPath: "endpointsApi",
    baseQuery: baseQuery(),
    tagTypes: [
        "endpoints"
    ],
    endpoints: function(builder) {
        return {
            getEndpoints: builder.query({
                query: function() {
                    return {
                        url: "/api/endpoints"
                    };
                },
                transformResponse: function(response) {
                    return response;
                }
            })
        };
    }
});
var useGetEndpointsQuery = endpointsApi.useGetEndpointsQuery;

var ProductType;
(function(ProductType) {
    ProductType["SINGLE_PRODUCT"] = "SINGLE_PRODUCT";
})(ProductType || (ProductType = {}));
var ProductStatus;
(function(ProductStatus) {
    ProductStatus["PRESALE"] = "PRESALE";
    ProductStatus["PURCHASEABLE"] = "PURCHASEABLE";
    ProductStatus["UNPURCHASEABLE"] = "UNPURCHASEABLE";
    ProductStatus["SUSPENDED"] = "SUSPENDED";
    ProductStatus["ARCHIVED"] = "ARCHIVED";
    ProductStatus["REMOVED"] = "REMOVED";
})(ProductStatus || (ProductStatus = {}));
var LinkedMediaType;
(function(LinkedMediaType) {
    LinkedMediaType["ON_DEMAND"] = "ON_DEMAND";
    LinkedMediaType["LIVE"] = "LIVE";
})(LinkedMediaType || (LinkedMediaType = {}));
var inventoryApi = createApi({
    reducerPath: "inventoryApi",
    baseQuery: baseQuery(),
    endpoints: function(builder) {
        return {
            getProduct: builder.query({
                query: function(id) {
                    return {
                        url: "/api/v0/user/inventory/products/".concat(id),
                        auth: true
                    };
                },
                transformResponse: function(response) {
                    return response.item;
                }
            })
        };
    }
});

export { EmailValidity, GenderType, LOCAL_STORAGE_KEY, LinkedMediaType, MarketingConsentType, ProductStatus, ProductType, PromotionType, PublisherDataShareScopes, PublisherDrmProviderName, PublisherStreamStatus, PublisherVideoTypeId, SocialSignupType, TypeOfRole, UserBonusType, UserConsentStatus, UserConsentType, VideoListingLiveDetailsStatus, VideoListingReplayStatus, VideoListingStreamTypes, VideoListingTypes, VideoOrder, addAuthStateListener, authApi, authChangePasswordAction, authDeleteUserAction, authDisconnectSocialAccountAction, authLoginAction, authLogoutAction, authLogoutAllDevicesAction, authNewPasswordAction, authReducer, authRefreshTokenAction, authResendVerifyCodeAction, authResetPasswordAction, authSignupAction, authSlice, authStorage, authValidateEmailAction, authVerifyAction, configInitialState, configReducer, configSlice, createPayment, endpointsApi, getEndpointData, hrefContainsId, inventoryApi, isChannelListing, isChannelPass, isPurchase, isTarrif, isUserLoggedIn, mediaApi, paymentApi, profileApi, publicApi, purchaseApi, setConfig, sharedDataAccess, updateTokens, useGetConfigQuery, useGetContactQuery, useGetCountriesQuery, useGetEndpointsQuery, useGetHomeProfileQuery, useGetLocationQuery, useGetMeWalletQuery, useGetTransactionsQuery, useGetVideoQuery, useLegacyGetVideoPlayQuery };
